/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateOrderItemDto } from './createOrderItemDto';


export interface CreateOrderCommand { 
    customerId?: number | null;
    azureAdUpn?: string | null;
    selectedDate?: string;
    deliveryPlace?: string | null;
    deliveryTime?: string | null;
    notes?: string | null;
    shopId?: number;
    serviceTypeId?: number;
    shopServiceTimeSlotId?: number | null;
    orderItems?: Array<CreateOrderItemDto> | null;
}

